export default {
  create( { userEmail }, data ) {
    return {
      email: userEmail,
      deleted: false, // The user was deleted, we keep him for a while and then wipe him
      deleteDate: null,

      /* This is special field that new users can write to.
      A cloud function listens for changes of this value */
      clientActivationRequest: 0,
      // findableByEmail: true,

      address: {
        address: '',
        city: '',
        zip: 0,
        phone: '',
        country: "NONE",
      },

      showOnboarding: true,

      /* Save 'abstract goals' that user checked during inital setup */
      abstractGoalSettings: null,

      settings: { // TODO: RENAME TO localization or 1 level up
        nightMode:  false,
        timezone:   'I/DONT/KNOW',
        language:   "en",
        dateformat: 'LLLL'
      },

      connectionSettings: {
        provider: '',
        apikey: 'NO API KEY'
      },

      dayplanner: {
        bgPictureOrColor: '',
      },

      /*
      backgroundSettings: {
        displayPictureNotColor: false,
        picture: 'url()',
        color: "#8fbf21"
      },
      */

      workmodeSettings: {
        enabled: true,
        breakDuration: 5,
        workDuration: 25
      },

      availabilitySettings: {
        mode: 'simple',
        timeSpentAtJob: [8, 8, 8, 8, 8, 0, 0],
        timeSpendOtherwise: [2, 2, 2, 2, 2, 4, 4],
        hoursSleep: 8,
        weeklyCommitmentRate: 0.5,
        cachedHoursAvailable: 5,
        startTime: 9,
        endTime: 17,
        freeTimeMethod: true,
        calendarFreeTimeMethod: 0
      },
      selectedIdols: [], // Firestore ok
      selectedGoals: [], // Firestore ok

      /*
      let testUser1_private = {
        X createdAt: Firestore.FieldValue.serverTimestamp(),
        X lastSeen: Firestore.FieldValue.serverTimestamp(),
        X visionboardSettings: {
          canvasScaleMethod: 'scroll',
          backgroundColor: '#000000',
          width: 1500,
          height: 800,
          allHeadlinesFontSize: 24,
          allCommitmentsFontSize: 15,
          showAllCommitments: true,
          showAllHeadlines: true,
          showAllProgress: true,
          customText: [],
          groupItems: false
        },
        X projectInviteList: {},
        X projects: {}, // LEGACY
        X goals: {}, // NEW (map id => load at startup)
        X timeslotCollectionList: {},
      };
      */
    }
  },

  fields: {
    email: { validate_bolt_type: 'String' },
    deleted: { validate_bolt_type: 'Boolean' },
    deleteDate: { validate_bolt_type: 'Timestamp' },
    address: { validate_bolt_type: 'UserSettingsAddress' },
    'address/address': { validate_bolt_type: 'String' },
    'address/city': { validate_bolt_type: 'String' },
    'address/zip': { validate_bolt_type: 'Number' },
    'address/phone': { validate_bolt_type: 'Phone' },
    'address/country': { validate_bolt_type: 'Country' },
    settings: { validate_bolt_type: 'UserSettingsSettings' },
    'settings/nightMode': { validate_bolt_type: 'Boolean' },
    'settings/timezone': {},
    'settings/language': {},
    'settings/dateformat': { validate_bolt_type: 'String' },
    connectionSettings: { validate_bolt_type: 'UserSettingsConnection' },
    'connectionSettings/provider': { validate_bolt_type: 'String' },
    'connectionSettings/apikey': { validate_bolt_type: 'String' },
    /* <REMOVE> */
    backgroundSettings: { validate_bolt_type: 'UserSettingsBackground' },
    'backgroundSettings/displayPictureNotColor': {},
    'backgroundSettings/picture': {},
    'backgroundSettings/color': {},
    /* </REMOVE> */
    dayplanner: { validate_bolt_type: 'UserSettingsDayplanner' },
    'dayplanner/bgPictureOrColor': {},
    workmodeSettings: { validate_bolt_type: 'UserSettingsWorkmode' },
    'workmodeSettings/enabled': { validate_bolt_type: 'Boolean' },
    'workmodeSettings/breakDuration': { validate_bolt_type: 'Number' },
    'workmodeSettings/workDuration': { validate_bolt_type: 'Number' },
    availabilitySettings: { validate_bolt_type: 'UserSettingsAvailability' },
    'availabilitySettings/mode': {},
    'availabilitySettings/timeSpentAtJob': {},
    'availabilitySettings/timeSpendOtherwise': {},
    'availabilitySettings/hoursSleep': {},
    'availabilitySettings/weeklyCommitmentRate': {},
    'availabilitySettings/cachedHoursAvailable': {},
    'availabilitySettings/startTime': {},
    'availabilitySettings/endTime': {},
    'availabilitySettings/freeTimeMethod': {},
    'availabilitySettings/calendarFreeTimeMethod': {},
    selectedIdols: {},
    selectedGoals: {},
    showOnboarding: { validate_bolt_type: 'Boolean' },
    abstractGoalSettings: { validate_bolt_type: 'String' },
    clientActivationRequest: { validate_bolt_type: 'ServerTimestamp' },
    /* -------------- REMOVE NEXT DB UPDATE -------------- */
    visionboardSettings: { validate_bolt_type: 'UserSettingsVisionboard' },
    'visionboardSettings/canvasScaleMethod': {},
    'visionboardSettings/width': {},
    'visionboardSettings/height': {},
    'visionboardSettings/backgroundColor': {},
    'visionboardSettings/allHeadlinesFontSize': {},
    'visionboardSettings/allCommitmentsFontSize': {},
    'visionboardSettings/showAllCommitments': {},
    'visionboardSettings/showAllHeadlines': {},
    'visionboardSettings/showAllProgress': {},
    'visionboardSettings/customText': {},
    'visionboardSettings/groupItems': {},
    'visionboardSettings/previewBase64': {},
  }
};
